import { FileManagementService } from 'src/app/services/property-matrixV2/services';
import { FooterDocumentDto } from 'src/app/services/property-matrixV2/models';
import { Component, OnInit } from '@angular/core';

import { ReportingService } from '../../services/reporting-service/reporting.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  footerDocuments: FooterDocumentDto[] = [];
  termsAndConditions: FooterDocumentDto;
  privacyPolicy: FooterDocumentDto;
  cookiePreferences: FooterDocumentDto;
  paiaManual: FooterDocumentDto;
  legalDisclaimer: FooterDocumentDto;

  constructor(
    private reportingService: ReportingService,
    private fileManagementService: FileManagementService
  ) { }

  ngOnInit(): void {
  }

  private readonly documentLinks: Record<string, string> = {
    'Terms & Conditions': 'https://propertymatrix.blob.core.windows.net/propertymatrix-prod/PropertyMatrixDocuments/Matrix_Terms_and_Conditions_LM.pdf',
    'Privacy Policy': 'https://propertymatrix.blob.core.windows.net/propertymatrix-prod/PropertyMatrixDocuments/Matrix_Privacy_Policy_LM.pdf',
    'Cookie Preferences': 'https://propertymatrix.blob.core.windows.net/propertymatrix-prod/PropertyMatrixDocuments/Matrix_Cookie_Policy_LM.pdf',
    'PAIA Manual': 'https://propertymatrix.blob.core.windows.net/propertymatrix-prod/PropertyMatrixDocuments/Matrix_PAIA_Manual_LM.pdf',
    'SACPLAN Tarrifs': 'https://propertymatrix.blob.core.windows.net/propertymatrix-prod/PropertyMatrixDocuments/Tariff-of-Fees-Not.pdf',
    'Legal Disclaimer': ''
  };

  async onLinkClick(linkName: string): Promise<void> {
    const url = this.documentLinks[linkName];

    if (!url) {
      console.log('Coming soon');
      return;
    }

    window.open(url, '_blank');
  }
}
